export enum TeamRelationType {
	Child,
	Related,
	Successor,
	Parent,
	Predecessor,
}
